import React, { useState } from 'react';
import { Alert, Snackbar, Dialog, DialogTitle, DialogContent } from '@mui/material';

import AccountsForm from '../patientForms/AccountsForm';
import { removeAccountById } from 'app/api-ws/accounts-ws';
import DeleteDialog from '../Dialogs/DeleteDialog';
import AccountViewDialog from '../Dialogs/AccountViewDialog';
import AccountsTableView from './AccountsTableView';
import useAuth from 'app/hooks/useAuth';

// const getStyles = (treatmentStatus) => {
//   switch (treatmentStatus) {
//     case 'Pending':
//       return { bgColor: '#fff1e7', textColor: '#fa8932' };
//     case 'Completed':
//       return { bgColor: '#eff8f6', textColor: '#66b5a3' };
//     case 'In Progress':
//       return { bgColor: '#eff8f6', textColor: '#66b5a3' };
//     case 'Cancelled':
//       return { bgColor: '#fce9e9', textColor: '#e35656' };
//     default:
//       return { bgColor: 'white', textColor: 'black' };
//   }
// };

function AccountsTable({ accountData, fetchAccountsById, setSelectedItems, selectedItems }) {
  const { user } = useAuth();
  const [snackBarMessage, setSnackBarMessage] = useState('');
  const [snackBarType, setSnackBarType] = useState('success');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedView, setSelectedView] = useState(null);
  const [viewDialog, setViewDialog] = useState(false);

  const [selectAll, setSelectAll] = useState(false);

  const handleCheckboxChange = (event, item) => {
    const isChecked = event.target.checked;
    const newSelectedItems = isChecked
      ? [...selectedItems, item]
      : selectedItems.filter((selectedItem) => selectedItem !== item);
    setSelectedItems(newSelectedItems);
    setSelectAll(newSelectedItems.length === accountData.length);
  };

  const handleSelectAllChange = (event) => {
    const isChecked = event.target.checked;
    const newSelectedItems = isChecked ? accountData : [];
    setSelectedItems(newSelectedItems);
    setSelectAll(isChecked);
  };

  const handleView = (item) => {
    handleCloseMenu();
    setSelectedView(item);
    setViewDialog(true);
  };

  const handleViewDialog = () => {
    setViewDialog(false);
    setSelectedView(null);
  };

  function showSnackBar() {
    setOpen(true);
  }

  function handleClose(_, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  }

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setSelectedAccount(item);
  };

  const handleEdit = () => {
    handleCloseMenu();
    setEditDialogOpen(true);
  };

  const handleEditDialogClose = () => {
    setEditDialogOpen(false);
    setSelectedAccount(null);
  };
  const handleCloseDialogSubmit = () => {
    fetchAccountsById();
    handleEditDialogClose();
  };

  const handleDeleteClick = (accountId) => {
    handleCloseMenu();
    setDialogOpen(false);
    removeAccountById(accountId._id, user?.authToken)
      .then(() => {
        fetchAccountsById();
      })
      .catch((error) => {
        console.log(error);
      });
    fetchAccountsById();
  };

  const handleDeleteDialogClick = () => {
    setDialogOpen(true);
  };

  const handleCancelDelete = () => {
    setDialogOpen(false);
  };

  return (
    <div>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={snackBarType}
          sx={{ width: '100%' }}
          variant="filled"
        >
          {snackBarMessage}
        </Alert>
      </Snackbar>
      <AccountsTableView
        selectAll={selectAll}
        handleSelectAllChange={handleSelectAllChange}
        accountData={accountData}
        selectedItems={selectedItems}
        handleCheckboxChange={handleCheckboxChange}
        handleClick={handleClick}
        anchorEl={anchorEl}
        handleCloseMenu={handleCloseMenu}
        handleView={handleView}
        handleEdit={handleEdit}
        handleDeleteDialogClick={handleDeleteDialogClick}
        fetchAccountsById={fetchAccountsById}
      />
      <Dialog open={editDialogOpen} onClose={handleCloseDialogSubmit} fullWidth maxWidth="sm">
        <DialogTitle>Edit Account</DialogTitle>
        <DialogContent>
          <AccountsForm
            account={selectedAccount}
            handleCloseDialog={handleEditDialogClose}
            handleCloseDialogSubmit={handleCloseDialogSubmit}
          />
        </DialogContent>
      </Dialog>

      <DeleteDialog
        open={dialogOpen}
        onClose={(e) => {
          e.stopPropagation();
          handleCancelDelete();
        }}
        onConfirm={(e) => {
          e.stopPropagation();
          handleDeleteClick(selectedAccount);
        }}
      />

      {selectedView && (
        <AccountViewDialog
          viewDialog={viewDialog}
          selectedView={selectedView}
          handleViewDialog={handleViewDialog}
        />
      )}
    </div>
  );
}

export default AccountsTable;
